import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-6 lg:px-8">
          <div className="bg-white border border-gray-200 rounded-3xl p-12 shadow-lg text-center">
            <div className="w-20 h-20 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-gray-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Zahlung abgebrochen
            </h1>
            <p className="text-gray-600 mb-10">
              Sie können es jederzeit erneut versuchen.
            </p>
            <Button
              onClick={() => navigate('/partner/registrieren')}
              size="lg"
              className="bg-brand-green hover:bg-brand-green-dark text-white text-lg px-10 py-6 rounded-2xl font-semibold"
            >
              Erneut zu Stripe
              <ArrowRight className="w-5 h-5 ml-3" />
            </Button>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PaymentCancelPage;